'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var ButtonLink = require('../../01.atoms/ButtonLink/ButtonLink.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-result-bar',
    cnWrapper = "".concat(CLASSNAME, "__wrapper"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnLink = "".concat(CLASSNAME, "__link");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function ResultBar(_ref) {
  var active = _ref.active,
      className = _ref.className,
      i18n = _ref.i18n,
      onSave = _ref.onSave,
      subline = _ref.subline,
      title = _ref.title;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(className, CLASSNAME)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnWrapper
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: cnTitle
  }, title), subline && /*#__PURE__*/React__default.createElement("div", null, subline)), /*#__PURE__*/React__default.createElement(ButtonLink, {
    title: i18n.save,
    onClick: function onClick() {
      return onSave(title);
    },
    iconLeft: active ? 'star-filled' : 'star',
    className: cnLink
  }));
}
ResultBar.propTypes = {
  /** True if selected */
  active: PropTypes.bool,

  /** Additional class name */
  className: PropTypes.string,

  /** Translation object */
  i18n: PropTypes.shape({
    save: PropTypes.string.isRequired
  }).isRequired,

  /** Callback function */
  onSave: PropTypes.func,

  /** Optional subline */
  subline: PropTypes.string,

  /** Title of bar */
  title: PropTypes.string.isRequired
};
ResultBar.defaultProps = {
  i18n: {},
  onSave: function onSave() {
    return void 0;
  }
};

module.exports = ResultBar;
